/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthLogoutResponse } from "./AuthLogoutResponse";

export type AuthLogoutResponseApiRespoonse = {
  data?: AuthLogoutResponse;
  status?: AuthLogoutResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AuthLogoutResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
